export type JumpDialogRoute = 'confirm' | 'insufficient'

/**
 * Decide which dialog a jump point tap opens. `null` (balance query not
 * settled yet) means the tap is a no-op.
 */
export function getJumpDialogRoute(
  gemBalance: number | undefined,
  gemPrice: number,
): JumpDialogRoute | null {
  if (gemBalance === undefined) return null
  return gemBalance >= gemPrice ? 'confirm' : 'insufficient'
}
